import React, { useEffect, useState } from 'react';
import AdContainer from 'src/components/ads';
import {
  useMobileTopAdExperiment,
  MobileTopAdExperimentType,
} from 'src/hooks/experiments';

export const MobileTopAd: React.FC = () => {
  const experiment = useMobileTopAdExperiment();
  const [removeMobileAd, setRemoveMobileAd] = useState<
    MobileTopAdExperimentType
  >(false);

  useEffect(() => setRemoveMobileAd(experiment), [experiment]);

  return removeMobileAd ? null : (
    <AdContainer
      placement="dubbelpanorama_top"
      min={0}
      max={860}
      format="toppanorama"
      spacing={{ top: '10px' }}
    />
  );
};
